import React, { memo } from "react";
import { Link } from "react-router-dom";

import "./Breadcrumbs.scss";

const RenderLinkText = ({ breadcrumbLink, breadcrumbText }) => {
  return (
    <>
      {breadcrumbText && (
        <span style={{ paddingLeft: "0.5%", paddingRight: "0.5%" }}>&#62;</span>
      )}
      <span>
        {breadcrumbLink ? (
          <Link
            style={{ textDecoration: "none", color: "black" }}
            to={breadcrumbLink}
          >
            {breadcrumbText}
          </Link>
        ) : (
          breadcrumbText
        )}
      </span>
    </>
  );
};

const Breadcrumbs = ({
  breadcrumbText = "",
  breadcrumbLink = "",
  nestedText = "",
  nestedLink = "",
  nestedText2 = "",
  nestedLink2 = "",
  nestedText3 = "",
  nestedLink3 = "",
  nestedText4 = "",
  nestedLink4 = "",
  className = "",
  isArray = false,
  breadcrumbsList = [],
}) => {
  return (
    <div
      className={`BreadcrumbSection ms-0 bg-white ${className} d-flex flex-wrap`}
    >
      <span>
        {/* <Link
          style={{ textDecoration: "none", color: "black" }}
          to="/dashboard"
          className="breadcrumb-link"
        >
          Dashboard
        </Link> */}
      </span>
      {isArray ? (
        <>
          {breadcrumbsList.map((data, index) => (
            <RenderLinkText
              key={index}
              breadcrumbText={data?.text}
              breadcrumbLink={data?.link}
            />
          ))}
        </>
      ) : (
        <>
          <RenderLinkText
            breadcrumbText={breadcrumbText}
            breadcrumbLink={breadcrumbLink}
          />
          <RenderLinkText
            breadcrumbText={nestedText}
            breadcrumbLink={nestedLink}
          />
          <RenderLinkText
            breadcrumbText={nestedText2}
            breadcrumbLink={nestedLink2}
          />
          <RenderLinkText
            breadcrumbText={nestedText3}
            breadcrumbLink={nestedLink3}
          />
          <RenderLinkText
            breadcrumbText={nestedText4}
            breadcrumbLink={nestedLink4}
          />
        </>
      )}
    </div>
  );
};

export default memo(Breadcrumbs);
